import React from 'react'
import { cn } from '../lib/cn'

export function PageFrame({ className, children }) {
    return (
        <div
            className={cn(
                'min-w-0 w-full space-y-5',
                className
            )}
        >
            {children}
        </div>
    )
}

export function PageHeader({ title, titleAccessory, description, actions, className }) {
    return (
        <header className={cn('flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', className)}>
            <div className="min-w-0">
                <div className="flex min-w-0 flex-wrap items-center gap-2">
                    <h1 className="sgez-page-header-title text-2xl font-bold tracking-tight text-sgez-ink">{title}</h1>
                    {titleAccessory}
                </div>
                {description ? (
                    <p className="mt-1 text-sm text-sgez-muted">{description}</p>
                ) : null}
            </div>
            {actions && <div className="flex w-full min-w-0 flex-wrap items-center gap-2 sm:w-auto sm:shrink-0 sm:justify-end">{actions}</div>}
        </header>
    )
}

export function EditorStatePage({ title, titleAccessory, description, className, children }) {
    return (
        <div className={cn('min-h-full bg-sgez-surface', className)}>
            <PageHeader
                title={title}
                titleAccessory={titleAccessory}
                description={description}
                className="mb-5"
            />
            {children}
        </div>
    )
}

export function WorkSurface({ className, children }) {
    return (
        <div className={cn('min-w-0 overflow-hidden rounded-xl border border-sgez-border-strong bg-sgez-surface shadow-sm', className)}>
            {children}
        </div>
    )
}

export function ToolbarSurface({ className, children }) {
    return (
        <div className={cn('min-w-0 border-b border-sgez-border bg-sgez-surface-subtle p-3 sm:p-4', className)}>
            {children}
        </div>
    )
}
